var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{attrs:{"id":"nav"}},[_c('app-navigation',{attrs:{"schedules":_vm.schedules}})],1),_c('v-main',[_c('router-view',{attrs:{"schedules":_vm.schedules}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }